export const PromotionTypes = {
    BUY_ONE_GET_ONE: 'BUY_ONE_GET_ONE',
} as const;

export type PromotionType = (typeof PromotionTypes)[keyof typeof PromotionTypes];
